/* eslint-disable react/jsx-key */
import React from "react";
import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import { useStyles } from "./styles";
import { TabProps, TabsProps } from "core/types";

const DottedTabs = (props: TabsProps) => {
  const { data } = props;

  return (
    <>
      <Typography component={"span"} variant={"body2"}>
        <Grid
          container
          direction={"row"}
          wrap={"wrap"}
          style={{ width: "100%" }}
          justify={"flex-start"}
        >
          {data.map((tab, i) => (
            <TabItem itemkey={i} key={i} tab={tab}></TabItem>
          ))}
        </Grid>
      </Typography>
    </>
  );
};
interface TabComponentProps {
  tab: TabProps;
  itemkey: any;
}
const TabItem = (props: TabComponentProps) => {
  const { t, i18n } = useTranslation();
  const { tab, itemkey } = props;

  const win: any = window;
  const langDir = i18n.dir(win["lang"] as string);
  const isRTL = langDir === "rtl";
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Grid
      onClick={() => tab.click(tab)}
      key={itemkey}
      item
      sm={2}
      xs={6}
      className={tab.selected ? classes.selectedTab : classes.tabItem}
    >
      <Box
        fontWeight={700}
        style={{
          direction: langDir,
          color: "#fff",
        }}
        width={"100%"}
        fontSize={theme.spacing(5)}
        pb={theme.spacing(0.25)}
        pt={theme.spacing(0.4)}
        letterSpacing={1}
      >
        {tab.name}
      </Box>
      {tab.selected && <DoddedUnderline></DoddedUnderline>}
    </Grid>
  );
};
const DoddedUnderline = () => {
  return (
    <Grid container direction={"row"} style={{ height: 0, width: 100 }}>
      <Grid
        item
        style={{
          borderRadius: 2,
          width: 32,
          borderBottom: "3px solid #fff",
        }}
      ></Grid>
      <Grid
        item
        style={{
          width: 12,
          opacity: 0.5,
          borderRadius: 2,
          borderBottom: "3px solid #fff",
          marginLeft: 4,
        }}
      ></Grid>
    </Grid>
  );
};

export { DottedTabs };
